export default __webpack_public_path__ + "static/img-dora-hacks-f159f152980f15af256a39c535f5be2b.png";